import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/apiClient";
import { Hand, Trophy, Users, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Community() {
  const [feed, setFeed] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const [f, c] = await Promise.all([api.get("/community/feed"), api.get("/challenges")]);
    setFeed(f.data); setChallenges(c.data); setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const highfive = async (a) => {
    setFeed((fs) => fs.map((x) => x.activity_id === a.activity_id ? { ...x, highfived: !x.highfived, highfive_count: x.highfive_count + (x.highfived ? -1 : 1) } : x));
    await api.post(`/community/highfive/${a.activity_id}`);
  };
  const join = async (ch) => {
    setChallenges((cs) => cs.map((x) => x.challenge_id === ch.challenge_id ? { ...x, joined: !x.joined, participant_count: x.participant_count + (x.joined ? -1 : 1) } : x));
    await api.post(`/challenges/${ch.challenge_id}/join`);
    toast.success(ch.joined ? "Left challenge" : `Joined "${ch.title}"! 🔥`);
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-[#FF6B6B] animate-spin" /></div>;

  return (
    <div>
      <h1 className="font-display font-bold text-4xl uppercase tracking-tight text-white mb-1">Community</h1>
      <p className="text-sm text-[#A0A0A0] mb-6">High-five your crew and crush global challenges together.</p>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <h2 className="font-bold text-white mb-3 flex items-center gap-2"><Users className="w-5 h-5 text-[#FF6B6B]" /> Activity Feed</h2>
          <div className="space-y-3">
            {feed.map((a) => (
              <div key={a.activity_id} className="bg-[#1E1E1E] border border-[#2A2A2A] rounded-2xl p-4 flex items-center gap-4" data-testid={`activity-${a.activity_id}`}>
                <img src={a.user_pic} alt="" className="w-11 h-11 rounded-full object-cover" />
                <div className="flex-1">
                  <p className="text-sm text-white"><span className="font-semibold">{a.user_name}</span> {a.text}</p>
                </div>
                <button data-testid={`highfive-${a.activity_id}`} onClick={() => highfive(a)} className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-semibold transition-colors ${a.highfived ? "bg-[#FF6B6B] text-black" : "bg-[#2A2A2A] text-white hover:bg-[#333333]"}`}>
                  <Hand className="w-4 h-4" /> {a.highfive_count}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="font-bold text-white mb-3 flex items-center gap-2"><Trophy className="w-5 h-5 text-[#4ECCD3]" /> Global Challenges</h2>
          <div className="space-y-3">
            {challenges.map((ch) => (
              <div key={ch.challenge_id} className="bg-[#1E1E1E] border border-[#2A2A2A] rounded-2xl p-4" data-testid={`challenge-${ch.challenge_id}`}>
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-bold text-white">{ch.title}</h3>
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#4ECCD3]/10 text-[#4ECCD3]">{ch.reward}</span>
                </div>
                <p className="text-xs text-[#A0A0A0] mb-3">{ch.goal}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-[#A0A0A0]">{ch.participant_count} joined</span>
                  <button data-testid={`join-challenge-${ch.challenge_id}`} onClick={() => join(ch)} className={`px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-all ${ch.joined ? "bg-[#2A2A2A] text-[#A0A0A0]" : "bg-[#FF6B6B] text-black hover:brightness-110"}`}>
                    {ch.joined ? "Joined" : "Join"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
